/** Resolve Beloved serverless API routes on web and inside Capacitor. */
export function belovedApiUrl(path) {
  const safePath = String(path || '').startsWith('/') ? String(path) : `/${String(path || '')}`;
  const configuredOrigin = String(process.env.REACT_APP_BELOVED_API_ORIGIN || '').trim().replace(/\/$/, '');
  if (configuredOrigin) return `${configuredOrigin}${safePath}`;

  try {
    if (typeof window !== 'undefined' && window.location?.protocol === 'capacitor:') {
      return `https://belovedapp.net${safePath}`;
    }
  } catch (error) {
    // Relative URLs remain correct in ordinary browsers and tests.
  }
  return safePath;
}

